export const onCallToSupportTeam = () => {
	window.open('tel:02142027');
};

export const scrollToTop = (behavior = 'smooth', position = { top: 0 }) => {
	window.scrollTo({
		...position,
		behavior,
	});
};
